import $ from "jquery";
import CONFIG from "@bd-core/config";
import compile from "@bd-utils/handlerbars-helper";
import { getState } from "@bd-stores/store";

export default class LocationInfo {
    init() {
        // Don't run this on static page
        if (!CONFIG.game.cfgLimit) return false;
        const self = this;
        $(document).on("bd__playersStateChanged", () => self.render());
    }

    render() {
        if ($("#locationInfo-item").length < 1) return;
        const players = getState().gameProgress.players;
        const template = $("#locationInfo-item").html();

        /**
         * All online players except the current user
         */
        const onlinePlayers = players.filter(
            (p) => p.isOnline && p.userId !== CONFIG.user.id,
        );

        $(".locationInfo__list").each(function () {
            const $context = $(this).parents(".js-locationInfo-context");
            const hasContext = $context.length > 0;

            const attrLocation = hasContext
                ? $context.attr("data-page-id")
                : undefined;

            const parsedInt = parseInt(attrLocation);

            /**
             * Valid page id should be number or if it's not a number, it
             * should at least have a character
             */
            const isValidPageId =
                (typeof attrLocation !== "undefined" &&
                    Number.isNaN(parsedInt) &&
                    attrLocation.length > 0) ||
                !Number.isNaN(parsedInt);

            const location = isValidPageId
                ? attrLocation
                : getState().userProgress.currentPageId;

            const roommate = onlinePlayers.filter(
                (p) => p.currentPageId == location,
            );

            const html = compile(template, { players: roommate });
            const isOnlyMe = roommate.length < 1;
            $(this).html(html);
            $(this)
                .parents(".locationInfo")
                .toggleClass("is-only-me", isOnlyMe);
        });
    }
}
